import TManageChannels from '../../templates/manageChannels';

function ManageChannels() {
  return <TManageChannels></TManageChannels>;
}

export default ManageChannels;
